<script>
    import { Line } from 'vue-chartjs';
    import { mapGetters } from 'vuex';

    export default {
        extends: Line,
        data() {
            return {
                options: {
                    scales: {
                        yAxes: [
                            {
                                title: {
                                    font: {
                                        weight: 'bold'
                                    }
                                },
                                weight: 100,
                                gridLines: {
                                    color: [
                                        'rgba(255, 255, 255, 0)',
                                        'rgba(255, 255, 255, 0)',
                                        'rgba(255, 255, 255, 0)',
                                        'rgba(255, 255, 255, 0)',
                                        'rgba(255, 255, 255, 0)',
                                        'rgba(255, 255, 255, 0)',
                                        'rgba(255, 255, 255, 0)'
                                    ],
                                    zeroLineWidth: 0,
                                    zeroLineColor: 'rgba(255, 255, 255, 0)',
                                    drawBorder: false
                                },
                                ticks: {
                                    fontColor: '#ffffff',
                                    fontSize: 10,
                                    padding: 14,
                                    autoSkip: true,
                                    maxTicksLimit: 5
                                }
                            }
                        ],
                        xAxes: [
                            {
                                gridLines: {
                                    color: 'rgba(255, 255, 255, 0)',
                                    tickMarkLength: 15,
                                    zeroLineWidth: 1,
                                    zeroLineColor: 'rgba(255, 255, 255, 0)',
                                    drawBorder: false
                                },
                                ticks: {
                                    fontColor: '#ffffff',
                                    fontSize: 12,
                                    padding: 5,
                                    min: 1,
                                    max: 31,
                                    step: 5,
                                    autoSkip: true,
                                    maxTicksLimit: 31
                                }
                            }
                        ]
                    },
                    legend: {
                        display: false
                    },
                    spanGaps: true,
                    responsive: true,
                    maintainAspectRatio: false,
                    bezierCurve: false
                }
            };
        },
        computed: {
            ...mapGetters('statistics', ['amplitudeGraph'])
        },
        watch: {
            ['amplitudeGraph']() {
                this.renderChart(this.amplitudeGraph, this.options);
            }
        },
        mounted() {
            setTimeout(() => {
                this.renderChart(this.amplitudeGraph, this.options);
            }, 500);
        }
    };
</script>
